var CONFUSEDCMS = CONFUSEDCMS || {};

(function ($) {

    CONFUSEDCMS.carousel = function () {

        var owlCarouselWrapper = $('.owl-carousel');
        owlCarouselWrapper.owlCarousel({
            margin: 10,
            nav: true,
            dots: true,
            loop: true,
            items: 1,
            responsive: {
                0: {
                    stagePadding: 40
                },
                901: {
                    stagePadding: 0
                }
            }
        });

    };
})(window.jQuery);